"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInfoCircle = exports.StyledDialog = exports.QuestionTypography = exports.ConfirmationTypography = exports.Buttons = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const StyledDialog = exports.StyledDialog = (0, _mui.styled)(_components.Dialog)({
  zIndex: 69420
});
const StyledInfoCircle = exports.StyledInfoCircle = (0, _mui.styled)(_icons.InfoCircle)(({
  theme
}) => ({
  color: theme.palette.info.main,
  fontSize: '90px'
}));
const ConfirmationTypography = exports.ConfirmationTypography = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3)
}));
const QuestionTypography = exports.QuestionTypography = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginTop: theme.spacing(3)
}));
const Buttons = exports.Buttons = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  marginTop: theme.spacing(6),
  width: '100%'
}));
